import React, {
  forwardRef,
  useEffect,
  useId,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import "./filterButton.css";
import { IoMdClose } from "react-icons/io";

const FilterButton = forwardRef(
  (
    { name, item, desc, canClear = true, clearCallback, tap, children },
    ref
  ) => {
    //function FilterButton({ name, desc, children }) {
    //{ name, desc, children }, props) {
    const menu2Ref = useRef();
    const menu2ParentRef = useRef();
    const isShown = useRef(false);

    const [showClearButton, setShowClearButton] = useState(false);
    const [title, setTitle] = useState("");

    const [id] = useState(useId());

    useImperativeHandle(ref, () => ({
      toka: (desc) => {
        setTitle(desc);
        //const re = desc.length > 0;
        setShowClearButton(desc.length > 0 && canClear);
      },
      hideMenu: () => {
        /*const elements =
          menu2Ref.current.parentElement.getElementsByTagName("ul");
        //const elements = menu2Ref.current.getElementsByTagName("ul");
        if (elements.length === 0) {
          return;
        }

        elements[0].hide();*/

        menu2Ref.current.click();
      },
    }));

    useEffect(() => {
      setTitle(desc);
      setShowClearButton(desc?.length > 0 && canClear);
    }, [desc]);

    function addEventListeners(e) {
      menu2Ref.current.addEventListener("shown.bs.dropdown", handleShowMenu);
      menu2Ref.current.addEventListener("hide.bs.dropdown", handleHideMenu);
    }

    function clickCloseList(e) {
      const { target } = e;

      if (menu2ParentRef.current == null || menu2Ref.current == null) {
        return;
      }

      const found = menu2ParentRef.current.contains(target);
      const foundParentOnly = menu2Ref.current.contains(target);
      if (foundParentOnly) {
        if (!isShown.current) {
          isShown.current = true;
        } else {
          menu2Ref.current.click();
        }
      } else if (!foundParentOnly && !found) {
        //outside everything
        menu2Ref.current.click();
      }

      console.log("--> CLICK OUT found; " + found + " TARGET: " + target);
    }

    const removeEventListeners = (e) => {
      if (menu2Ref.current == null) return;

      menu2Ref.current.removeEventListener("shown.bs.dropdown", handleShowMenu);
      menu2Ref.current.removeEventListener("hide.bs.dropdown", handleHideMenu);

      document.removeEventListener("click", clickCloseList);
    };

    const handleShowMenu = (event, item, options) => {
      //isShown.current = true;
      //  event.stopPropagation();
      //    event.preventDefault();

      document.addEventListener("click", clickCloseList);

      if (tap) tap(event, true);
    };

    const handleHideMenu = (event, item, options) => {
      isShown.current = false;

      document.removeEventListener("click", clickCloseList);

      if (tap) tap(event, false);
    };

    useEffect(() => {
      addEventListeners();
      return () => {
        removeEventListeners();
      };
    }, []);

    function clearInput() {
      //setShowClearButton(false);
      if (clearCallback) {
        clearCallback(item);
      }
      //  inputRef.current.value = "";
      //  inputRef.current.focus();

      // selectValue(null);
    }
    const selectedClass =
      title?.length > 0 ? "form-control-plaintext button-container" : ""; //"form-control-plaintext" : "";
    const selectedMiniClass = title?.length > 0 ? "form-control-mini" : "";

    return (
      <>
        {/*  <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingPassword"
            placeholder="Password"
          />
          <label htmlFor="floatingPassword">Password</label>
        </div>*/}

        <div className="form-floating1 mb-3">
          <div ref={menu2ParentRef} className="form-control1">
            <button
              ref={menu2Ref}
              className={`btn btn-secondary dropdown-toggle btn-sm btn-info form-control-inside ${selectedClass}`}
              type="button"
              id={id}
              data-bs-toggle="dropdown"
              data-bs-auto-close="false"
              aria-expanded="false"
              style={{ color: "transparent" }}
            >
              {name}
            </button>
            {children}
          </div>
          <label
            htmlFor="floatingInput"
            className={`${selectedMiniClass} form-control-super`}
          >
            {name}
          </label>
          <label htmlFor="floatingInputInside" className={`${selectedClass}`}>
            {title}
          </label>
          <span
            onClick={(e) => {
              clearInput(item);
            }}
            className={`form-control-clear glyphicon glyphicon-remove form-control-feedback1 ${
              showClearButton ? "" : "hideButton"
            }`}
            style={{
              right: "0px",
              position: "absolute",
              zIndex: 3,
              padding: "1rem 0.15rem",
              top: "0",
            }}
          >
            <IoMdClose
              style={{
                width: "20px",
                height: "20px",
                background: "rgba(255, 255, 255, 0.3)",
                borderRadius: "10px",
              }}
            />
          </span>
        </div>
      </>
    );
  }
);

export default FilterButton;
